import React from 'react';
import 'react-spring-bottom-sheet/dist/style.css'
import styled from 'styled-components';
import {Button, useToast} from "@chakra-ui/react";
import {Header, Title} from "../sheet";
import useFeedback from "../../../utils/use_feedback";
import {useUnban} from "../../../api/moderation";

const UnbanSheet = styled(({className, community, username, onClose}) => {

        const {feedbackCh} = useFeedback();
        const unban = useUnban(feedbackCh);
        const toast = useToast();
        const handleUnban = async () => {
            try {
                await unban(username, community);
                toast({
                    title: `Successfully unbanned!`,
                    status: 'success',
                    isClosable: true,
                });
            } catch {
            }
            onClose();
        };

        return (
            <div className={className}>

                <Header>
                    <Title>Unban</Title>
                </Header>

                <p>Are you sure you want to unban {username}?</p>

                <Button variant={"grey"} style={{width: '100%'}} mt={6} onClick={handleUnban}>Yes</Button>

            </div>
        );
    }
)`
    p {
      font-size: 17px;
    }
`;

export default UnbanSheet;
